export default __webpack_public_path__ + "static/media/verified.4974f803.svg";